/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantExitTemp } from '../../models/TenantExitTemp';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `TenantExitTemp` model.
 */
@Injectable()
export class TenantExitTempApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, errorHandler);
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - Model instance data
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public patchOrCreate(data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   *
   * @param {any} id TenantExitTemp id
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - An object of model property name/value pairs
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public patchAttributes(id: any, data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Saves exit charges to temp
   *
   * @param {object} data Request data.
   *
   *  - `leaseId` – `{number}` - 
   *
   *  - `tenantId` – `{number}` - 
   *
   *  - `newCharges` – `{any}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `data` – `{Object}` - 
   */
  public saveCharges(leaseId: any, tenantId: any, newCharges: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/saveCharges";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    if (typeof newCharges !== 'undefined' && newCharges !== null) _urlParams.newCharges = newCharges;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Gets existing exit charges
   *
   * @param {number} leaseId 
   *
   * @param {number} tenantId 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public getExitCharges(leaseId: any, tenantId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/getExitCharges";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Takes a snapshot of the outstanding invoices, deposits and wallet balance
   *
   * @param {number} leaseId 
   *
   * @param {number} tenantId 
   *
   * @param {boolean} changeExitStep 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public applyExitCharges(leaseId: any, tenantId: any, changeExitStep: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/applyExitCharges";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    if (typeof changeExitStep !== 'undefined' && changeExitStep !== null) _urlParams.changeExitStep = changeExitStep;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Perform temp move out step
   *
   * @param {number} leaseId 
   *
   * @param {number} tenantId 
   *
   * @param {string} moveOutDate 
   *
   * @param {string} exitChecklistFileName 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public moveOut(leaseId: any, tenantId: any, moveOutDate: any, exitChecklistFileName: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/moveOut";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    if (typeof moveOutDate !== 'undefined' && moveOutDate !== null) _urlParams.moveOutDate = moveOutDate;
    if (typeof exitChecklistFileName !== 'undefined' && exitChecklistFileName !== null) _urlParams.exitChecklistFileName = exitChecklistFileName;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Calculates refund amount based on temp values
   *
   * @param {number} leaseId 
   *
   * @param {number} tenantId 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public getRefundAmount(leaseId: any, tenantId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/getRefundAmount";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Saves refund details to temp
   *
   * @param {object} data Request data.
   *
   *  - `leaseId` – `{number}` - 
   *
   *  - `tenantId` – `{number}` - 
   *
   *  - `refundDetails` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `data` – `{Object}` - 
   */
  public saveRefundDetails(leaseId: any, tenantId: any, refundDetails: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/saveRefundDetails";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    if (typeof refundDetails !== 'undefined' && refundDetails !== null) _urlParams.refundDetails = refundDetails;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Takes a snapshot of the outstanding invoices, deposits and wallet balance before returning data
   *
   * @param {number} leaseId 
   *
   * @param {number} tenantId 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TenantExitTemp` object.)
   * </em>
   */
  public getCurrentTempRecord(leaseId: any, tenantId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TenantExitTemps/getCurrentTempRecord";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof leaseId !== 'undefined' && leaseId !== null) _urlParams.leaseId = leaseId;
    if (typeof tenantId !== 'undefined' && tenantId !== null) _urlParams.tenantId = tenantId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantExitTemp`.
   */
  public getModelName() {
    return "TenantExitTemp";
  }
}
